import createVueApp from '../../shared/vue/create-app';
import initAdvertModalComponents from './advert-modals';
import initCustomInputsComponents from '../inputs/custom-inputs';
import initCustomControls from '../custom-controls';
import {Field} from 'vee-validate';
import {initCurrencyPriceComponents} from '../inputs/currency-price';
import initAddressSelectorComponent from '../inputs/address-selector';
import {initCascadeModals} from '../modals/cascade-modals';
import {initCascadeModalMediator} from '../modals/cascade-modal-mediator';
import initAdaptiveShareBlockComponent from '../../components/adaptive-share-block'

function initAdvertModals(options) {
    const app = createVueApp({
    });

    app.component('Field', Field);
    initAdvertModalComponents(app);
    initCustomInputsComponents(app);
    initCustomControls(app);
    initCurrencyPriceComponents(app);
    initAddressSelectorComponent(app);
    initCascadeModals(app);
    initCascadeModalMediator(app);
    initAdaptiveShareBlockComponent(app);

    app.mount(options.el);

    return app;
}


export {initAdvertModals};
